import { Injectable, signal, effect } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SidebarStateService {
  readonly isExpandedSubject = new BehaviorSubject<boolean>(true);
  isExpanded$ = this.isExpandedSubject.asObservable();

  readonly isExpandedSignal = signal(true);

  constructor() {
    effect(() => {
      this.isExpandedSubject.next(this.isExpandedSignal());
    });
  }

  setState(expanded: boolean, showSidebar: boolean): void {
    if (showSidebar) {
      this.isExpandedSignal.set(expanded);
    } else {
      this.isExpandedSignal.set(false);
    }
  }

  toggleExpand(): void {
    this.isExpandedSignal.update((v) => !v);
  }
}
